import React from "react";
import PropTypes from "prop-types";
import { ORGANIZATION_TYPE } from "@constants";
import { Switch } from "../../../../../components";

const InvoicingSection = ({
	details,
	Type,
	updateDetails,
	flags,
	handleOnClickManualReconciliation,
	checkingOrganizationFutureOfficerJobs,
}) => {
	const { lang } = global;
	const { LAW_ENFORCEMENT_DEPARTMENT, COORDINATOR } = ORGANIZATION_TYPE;

	const {
		NonRKPayInvoicingEnabled,
		NonRKPayPaymentsEnabled,
		InvoicingV3Enabled,
		PayCodesEnabled,
		UsePTAEOCode,
		WorkerCompensationFeeEnabled,
		VehicleInvoicingEnabled,
		ManualReconciliationEnabled,
		AgencyInvoicingDisputes,
		InstantPayEnabledV3,
		OfficerInvoicingV3Enabled,
		SameDayPayEnabled,
		InstantPayEnabledOfficerV3,
	} = details;

	const {
		workersCompensationFee,
		instantPayV3,
		officerInvoicingV3,
		enforceV2NonrkpayInvoicingEnabled,
		agencyInvoicingDisputesToggle,
	} = flags;

	return (
		<>
			<h5>
				<strong>{lang.t("Invoicing Settings")}:</strong>
			</h5>
			<div className="row row-header">
				<If condition={!!instantPayV3}>
					<div className="col-md-4 col-xs-6 status-indicator">
						<Switch
							on={InstantPayEnabledV3}
							onClick={updateDetails("InstantPayEnabledV3")}
							disabled={!SameDayPayEnabled || !InvoicingV3Enabled}
						/>
						<br />
						<small>{lang.t("Agency Invoice IP")}</small>
					</div>
				</If>
				<If condition={!!officerInvoicingV3}>
					<div className="col-md-4 col-xs-6 status-indicator">
						<Switch
							on={InstantPayEnabledOfficerV3}
							onClick={updateDetails("InstantPayEnabledOfficerV3")}
							disabled={!OfficerInvoicingV3Enabled}
						/>
						<br />
						<small>{lang.t("Officer Invoice IP")}</small>
					</div>
				</If>
				{agencyInvoicingDisputesToggle &&
					(Type === LAW_ENFORCEMENT_DEPARTMENT || Type === COORDINATOR) && (
						<div className="col-md-3 col-xs-6 status-indicator">
							<Switch
								disabled={
									!NonRKPayInvoicingEnabled ||
									!NonRKPayPaymentsEnabled ||
									!InvoicingV3Enabled
								}
								on={AgencyInvoicingDisputes}
								onClick={updateDetails("AgencyInvoicingDisputes")}
							/>
							<br />
							<small>{lang.t("Agency Invoice Disputes (beta)")}</small>
						</div>
				)}
				<If condition={!!enforceV2NonrkpayInvoicingEnabled}>
					<div className="col-md-4 col-xs-6 status-indicator">
						<Switch
							on={ManualReconciliationEnabled}
							onClick={handleOnClickManualReconciliation}
							disabled={!InvoicingV3Enabled || checkingOrganizationFutureOfficerJobs}
							loading={checkingOrganizationFutureOfficerJobs}
						/>
						<br />
						<small>{lang.t("Default Manual Reconcilliation")}</small>
					</div>
				</If>
				<div className="col-md-4 col-xs-6 status-indicator">
					<Switch
						on={PayCodesEnabled}
						onClick={updateDetails("PayCodesEnabled")}
					/>
					<br />
					<small>{lang.t("Pay Codes")}</small>
				</div>
				<div className="col-md-4 col-xs-6 status-indicator">
					<Switch
						on={UsePTAEOCode}
						onClick={updateDetails("UsePTAEOCode")}
					/>
					<br />
					<small>{lang.t("PTAEO codes")}</small>
				</div>
				<If condition={workersCompensationFee}>
					<div className="col-md-4 col-xs-6 status-indicator">
						<Switch
							on={WorkerCompensationFeeEnabled}
							onClick={updateDetails("WorkerCompensationFeeEnabled")}
						/>
						<br />
						<small>{lang.t("Workers Protection")}</small>
					</div>
				</If>
				<div className="col-md-4 col-xs-6 status-indicator">
					<Switch
						disabled={!InvoicingV3Enabled}
						on={VehicleInvoicingEnabled}
						onClick={updateDetails("VehicleInvoicingEnabled")}
					/>
					<br />
					<small>{lang.t("Vehicle Invoicing: Officer Pay Opt-Out")}</small>
				</div>
			</div>
		</>
	);
};

InvoicingSection.propTypes = {
	details: PropTypes.object.isRequired,
	Type: PropTypes.any.isRequired,
	updateDetails: PropTypes.func.isRequired,
	flags: PropTypes.object.isRequired,
	handleOnClickManualReconciliation: PropTypes.func.isRequired,
	checkingOrganizationFutureOfficerJobs: PropTypes.bool.isRequired,
};

export default InvoicingSection;
